import { render } from "./Indicator.vue?vue&type=template&id=64c7cedf&scoped=true"
import script from "./Indicator.vue?vue&type=script&lang=js"
export * from "./Indicator.vue?vue&type=script&lang=js"

import "./Indicator.vue?vue&type=style&index=0&id=64c7cedf&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c7cedf"]])

export default __exports__